import { ReactComponent as UKFlag } from 'assets/icons/uk-flag.svg';
import { ReactComponent as PolandFlag } from 'assets/icons/poland-flag.svg';
import { ReactComponent as GermanFlag } from 'assets/icons/german-flag.svg';
import { ReactComponent as CzechFlag } from 'assets/icons/czech-flag.svg';

export { UKFlag, PolandFlag, GermanFlag, CzechFlag };

export const LANGUAGE_FLAG_MAP = {
	pl: PolandFlag,
	en: UKFlag,
	de: GermanFlag,
	cs: CzechFlag,
} as const;
